import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedeschauffeurserviceinbanglore() {



  const cardData =
  {
    keyword: 'Mercedes Chauffeur Services in Bangalore',
    heading: 'Aaryan Travels: Mercedes Chauffeur Services in Bangalore',
    headingDescription: 'Aaryan Travels offers premium Mercedes Chauffeur Services in Bangalore for corporate leaders, VIP guests, and luxury travelers who value elegance and professionalism. Whether it is airport transfers from Kempegowda International Airport, high-profile business meetings in Whitefield or Electronic City, or grand wedding entries in Koramangala or Indiranagar, our chauffeur-driven Mercedes sedans provide a refined travel experience. With uniformed drivers, plush leather interiors, and on-request amenities like bottled water and Wi-Fi, Aaryan Travels ensures sophistication and convenience across the city. For those seeking top-tier luxury transportation, our Mercedes chauffeur services in Bangalore deliver class and comfort at every step.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green paradise in the heart of Bangalore, renowned for its diverse plant species and peaceful lakes. The iconic Glass House, inspired by London’s Crystal Palace, becomes the center of attraction during the biannual flower show. Morning joggers, bird watchers, and nature lovers flock here for its refreshing ambiance. Century-old trees and scenic pathways make it a perfect retreat from urban life. Lalbagh is Bangalore’s evergreen oasis of beauty and tranquility."
  },
  {
    "title": "Bangalore Palace",
    "description": "Built in 1878, Bangalore Palace resembles a European castle with its fortified towers, elegant woodwork, and sprawling courtyards. Visitors can explore royal artifacts, vintage photographs, and grand halls once used for celebrations. The vast grounds also host concerts and cultural events. Its Tudor-style architecture adds old-world charm. Bangalore Palace is the city’s majestic symbol of royal heritage."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park spans over 300 acres of lush greenery and is a popular spot for morning walks, cycling, and family picnics. The park is dotted with bamboo groves, vibrant flower beds, and colonial-era statues. Nearby landmarks include the State Central Library and High Court. Kids love the toy train rides inside the park. Cubbon Park is Bangalore’s refreshing natural escape."
  },
  {
    "title": "ISKCON Temple",
    "description": "ISKCON Temple in Rajajinagar is one of the largest Krishna temples in the world, built with white marble and intricate carvings. The serene chants and devotional atmosphere attract visitors from across the globe. The temple complex includes a cultural museum and prasadam counters serving delicious offerings. Its hilltop location offers beautiful city views. ISKCON is Bangalore’s beacon of spiritual bliss."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from the city, Nandi Hills is a popular sunrise viewpoint offering spectacular misty valleys. Once used as Tipu Sultan’s summer retreat, the hilltop fort adds historical charm. Visitors enjoy trekking, cycling, and scenic drives at dawn. The cool breeze and cloud-kissed views create magical moments. Nandi Hills is Bangalore’s refreshing getaway into nature."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is the seat of Karnataka’s state legislature and a remarkable example of Neo-Dravidian architecture. Built with over 6,000 granite blocks, it stands tall with majestic domes and ornate carvings. The building is beautifully illuminated on Sunday evenings. It represents power, governance, and cultural pride. Vidhana Soudha is Bangalore’s grand monument of democracy."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park offers thrilling safari experiences where visitors can spot tigers, lions, bears, and elephants roaming in natural habitats. The park also features a butterfly enclosure, reptile house, and zoo area. It is a great place for educational trips and wildlife photography. The lush forest surroundings make it a serene nature escape. Bannerghatta is Bangalore’s wild haven of adventure."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most buzzing shopping lane filled with fashion boutiques, accessory stalls, and street-side bargains. Visitors love exploring narrow alleys packed with colorful merchandise. Street food carts selling chaats and desserts add to the lively vibe. It’s a hotspot for youngsters and tourists alike. Commercial Street is Bangalore’s vibrant hub of style and fun."
  },
  {
    "title": "UB City",
    "description": "UB City is Bangalore’s premium luxury complex featuring international brands, fine dining restaurants, and high-end lounges. Its open courtyard often hosts live music and fashion shows. Visitors enjoy gourmet experiences and glamorous nightlife. The elegant architecture adds a touch of sophistication. UB City is Bangalore’s upscale destination of luxury and leisure."
  },
  {
    "title": "MG Road and Brigade Road",
    "description": "MG Road and Brigade Road are iconic stretches known for nightlife, shopping, and entertainment. The streets are lined with pubs, bookstores, cafes, and fashion outlets. During festivals, they glow with lights and buzzing crowds. Street performers and artists add character to the area. MG Road is Bangalore’s energetic pulse of urban culture."
  }
],



"services": [
  {
    "name": "Mercedes Chauffeur Services in Bangalore",
    "description": "Mercedes Chauffeur Services in Bangalore offer premium chauffeur-driven luxury vehicles tailored for corporate clients, special events, and executive travel. The service emphasizes professionalism, punctuality, and comfort, ensuring a seamless and sophisticated experience with highly trained drivers familiar with Bangalore’s routes."
  },
  {
    "name": "Chauffeur Driven Mercedes Bangalore",
    "description": "Chauffeur Driven Mercedes Bangalore provides expertly driven Mercedes cars, combining elegance and convenience for business executives and VIPs. The chauffeurs are trained to offer courteous and discreet service, catering to all transportation needs with utmost care and attention."
  },
  {
    "name": "Mercedes Rental with Driver Bangalore",
    "description": "Mercedes Rental with Driver Bangalore offers flexible rental packages for clients seeking luxury vehicles accompanied by professional drivers. Ideal for corporate travel, airport transfers, and events, this service ensures reliability and a stress-free journey."
  },
  {
    "name": "Executive Mercedes Taxi Bangalore",
    "description": "Executive Mercedes Taxi Bangalore specializes in premium taxi services with luxury Mercedes vehicles for executives and business travelers. It guarantees privacy, timely pickups, and a comfortable ride with expert chauffeurs."
  },
  {
    "name": "Corporate Mercedes Car Hire Bangalore",
    "description": "Corporate Mercedes Car Hire Bangalore caters to companies requiring luxury transport solutions for executives and clients. The service focuses on providing well-maintained vehicles and professional chauffeurs to uphold corporate standards and ensure smooth travel experiences."
  },
  {
    "name": "Premium Mercedes Services Bangalore",
    "description": "Premium Mercedes Services Bangalore deliver top-tier luxury transportation with a fleet of Mercedes sedans and SUVs. Perfect for high-profile events, business meetings, and airport transfers, the service combines comfort, style, and professionalism."
  },
  {
    "name": "Best Mercedes Rental Bangalore",
    "description": "Best Mercedes Rental Bangalore is known for its quality fleet, competitive pricing, and exceptional customer service. With a wide range of Mercedes models available, clients receive personalized service that matches their luxury travel requirements."
  },
  {
    "name": "Online Mercedes Booking Bangalore",
    "description": "Online Mercedes Booking Bangalore offers an easy-to-use digital platform for quick and hassle-free booking of Mercedes vehicles. Users benefit from instant confirmations, real-time tracking, and flexible scheduling, enhancing the overall convenience."
  },
  {
    "name": "Luxury Mercedes Cab Bangalore",
    "description": "Luxury Mercedes Cab Bangalore provides elegant and comfortable rides with high-end Mercedes vehicles. Whether for business or leisure, the service ensures a smooth and stylish travel experience with well-trained chauffeurs."
  },
  {
    "name": "Affordable Mercedes Hire Bangalore",
    "description": "Affordable Mercedes Hire Bangalore combines luxury with cost-effectiveness, making Mercedes rentals accessible for a broader clientele. Despite competitive pricing, the service maintains high standards of vehicle condition and driver professionalism."
  },
  {
    "name": "Mercedes Benz Chauffeur Bangalore",
    "description": "Mercedes Benz Chauffeur Bangalore specializes in chauffeur-driven luxury rides with the latest Mercedes Benz models. Drivers are trained in etiquette and city navigation to provide an unmatched luxury travel experience."
  },
  {
    "name": "Mercedes Sedan/SUV Bangalore",
    "description": "Mercedes Sedan/SUV Bangalore offers a choice between sleek sedans and spacious SUVs, catering to diverse travel preferences. Both options provide premium interiors, advanced features, and professional chauffeurs for any occasion."
  },
  {
    "name": "Mercedes Event Transport Bangalore",
    "description": "Mercedes Event Transport Bangalore delivers luxury transportation solutions for weddings, corporate events, and special occasions. The service includes personalized arrangements, ensuring timely pickups and elegant arrivals."
  },
  {
    "name": "Prestige Mercedes Services Bangalore",
    "description": "Prestige Mercedes Services Bangalore represent the pinnacle of luxury transport, offering exclusive Mercedes models with impeccable chauffeur service. Ideal for VIP clients and discerning travelers seeking the utmost in style and comfort."
  },
  {
    "name": "Bangalore Elite Mercedes",
    "description": "Bangalore Elite Mercedes provides a premium fleet of Mercedes vehicles combined with elite chauffeur services. Designed for clients who demand the highest standards in luxury, punctuality, and professionalism for all travel needs."
  }
],
"tableData": [
  ["Mercedes Chauffeur Services in Bangalore", "Chauffeur Driven Mercedes Bangalore"],
  ["Mercedes Rental with Driver Bangalore", "Executive Mercedes Taxi Bangalore"],
  ["Corporate Mercedes Car Hire Bangalore", "Premium Mercedes Services Bangalore"],
  ["Best Mercedes Rental Bangalore", "Online Mercedes Booking Bangalore"],
  ["Luxury Mercedes Cab Bangalore", "Affordable Mercedes Hire Bangalore"],
  ["Mercedes Benz Chauffeur Bangalore", "Mercedes Sedan/SUV Bangalore"],
  ["Mercedes Event Transport Bangalore", "Prestige Mercedes Services Bangalore"],
  ["Bangalore Elite Mercedes", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mercedes Chauffeur Services in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers premium Mercedes chauffeur services in Bangalore, combining luxury, comfort, and professionalism."
  },
  {
    "WhyChooseheading": "Fleet of Well-Maintained Mercedes Vehicles",
    "WhyChoosedescription": "Travel in style with our range of meticulously maintained Mercedes sedans and SUVs."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs",
    "WhyChoosedescription": "Our professional drivers provide punctual, discreet, and safe chauffeur services tailored to your needs."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Cars",
    "WhyChoosedescription": "All Mercedes vehicles are regularly cleaned and sanitized for your safety and comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear, all-inclusive pricing covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized chauffeur service packages to suit your schedule."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service Across Bangalore",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs for a smooth and luxurious travel experience."
  }
]




















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes chauffeur services in Bangalore?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes chauffeur services in Bangalore for a luxurious and comfortable travel experience.',
  },
  {
    question: 'How can I book Mercedes chauffeur services in Bangalore?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Bangalore.',
  },
  {
    question: 'What Mercedes models are available for chauffeur services in Bangalore?',
    answer: 'Aaryan Travels offers a range of Mercedes models including E-Class, S-Class, and luxury SUVs for chauffeur services in Bangalore.',
  },
  {
    question: 'Are the chauffeurs experienced and trained for Mercedes services in Bangalore?',
    answer: 'Absolutely. Our chauffeurs are professionally trained, punctual, and committed to providing a premium and safe driving experience.',
  },
  {
    question: 'Can Mercedes chauffeur services be booked for corporate and personal events in Bangalore?',
    answer: 'Yes, these services are ideal for corporate travel, airport transfers, weddings, and special occasions in Bangalore.',
  },
  {
    question: 'Is the Mercedes chauffeur service available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels offers round-the-clock Mercedes chauffeur services to suit your schedule in Bangalore.',
  },
  {
    question: 'Are hygiene and safety protocols followed for Mercedes chauffeur services?',
    answer: 'All vehicles are sanitized thoroughly, and chauffeurs adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are accepted for Mercedes chauffeur services in Bangalore?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mercedes chauffeur service period in Bangalore?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mercedes chauffeur service.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karthik Reddy',
    feedback: 'Aaryan Travels provided excellent Mercedes chauffeur services in Bangalore with professional and courteous drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Divya Sharma',
    feedback: 'Highly recommend Aaryan Travels for Mercedes chauffeur services in Bangalore. Luxurious cars and impeccable service.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const mercedesChauffeurBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Chauffeur Services in Bangalore",
  "description": "Aaryan Travels provides premium chauffeur-driven Mercedes rentals in Bangalore, including executive taxis, corporate car hires, luxury sedans and SUVs with professional drivers.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Mercedes Chauffeur Service",
  "keywords": "Mercedes Chauffeur Services in Bangalore, Chauffeur Driven Mercedes Bangalore, Mercedes Rental with Driver Bangalore, Executive Mercedes Taxi Bangalore, Corporate Mercedes Car Hire Bangalore, Premium Mercedes Services Bangalore, Best Mercedes Rental Bangalore, Online Mercedes Booking Bangalore, Luxury Mercedes Cab Bangalore, Affordable Mercedes Hire Bangalore, Mercedes Benz Chauffeur Bangalore, Mercedes Sedan/SUV Bangalore, Mercedes Event Transport Bangalore, Prestige Mercedes Services Bangalore, Bangalore Elite Mercedes"
};







  return (
    <div>

<Helmet>
  <title>Mercedes Chauffeur Services in Bangalore | Luxury Mercedes Rentals | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium chauffeur-driven Mercedes services in Bangalore with Aaryan Travels. Executive and corporate Mercedes rentals with professional drivers for all your needs."
  />
  <meta
    name="keywords"
    content="Mercedes Chauffeur Services in Bangalore, Chauffeur Driven Mercedes Bangalore, Mercedes Rental with Driver Bangalore, Executive Mercedes Taxi Bangalore, Corporate Mercedes Car Hire Bangalore, Premium Mercedes Services Bangalore, Best Mercedes Rental Bangalore, Online Mercedes Booking Bangalore, Luxury Mercedes Cab Bangalore, Affordable Mercedes Hire Bangalore, Mercedes Benz Chauffeur Bangalore, Mercedes Sedan/SUV Bangalore, Mercedes Event Transport Bangalore, Prestige Mercedes Services Bangalore, Bangalore Elite Mercedes"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesChauffeurBangaloreSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedeschauffeurserviceinbanglore;